export default "__VITE_ASSET__DL9Cn$Ks__"